import { clsx } from "clsx";
import type { HTMLAttributes } from "react";
import { TruncateText } from "widgets";

import css from "../../styles/Cells.module.scss";

// NOTE: This component is intended for use in legacy code only.
// For new components, prefer using TruncateText directly from widgets package.
interface TruncateTextAutosizeProps extends HTMLAttributes<HTMLSpanElement> {
  text: string;
}

export const TruncateTextAutosize = ({ text, className, ...props }: TruncateTextAutosizeProps) => {
  return (
    <span className={clsx(css.truncate_container, className)} {...props}>
      <span className={css.truncate_autosize} aria-hidden>
        {text}
      </span>
      <TruncateText text={text} className={css.truncate_content} />
    </span>
  );
};
